import { routeNames } from '../../../util/Constants';
import lazyWithRetry from '../../../util/lazyWithRetry';

const Home = lazyWithRetry(() => import('../../page/Home/Home'));

const menuLinks = [
  {
    icon: '',
    name: 'home',
    title: 'Home',
    component: Home,
    path: routeNames.home,
  },
];

export default menuLinks;
